module.exports = __webpack_public_path__ + "images/722f5036825d7e98fec04e816ba0f63e.png";